import { AccountInfo } from "@azure/msal-browser";

const isDatahubAdmin = (account: AccountInfo | null): boolean => {
    const idTokenClaims = account?.idTokenClaims as any;
    return idTokenClaims !== null && idTokenClaims !== undefined && idTokenClaims.roles !== undefined && idTokenClaims.roles.includes('Datahub.Admin');
};

export {
    isDatahubAdmin
}